$(document).ready(function(){

  $('.quantity__input').keypress(function (e) {
if(event.keyCode == 13){
        event.preventDefault();
    }

});
  
  
$('.img-full-width').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 5000,
});  
  
  
  
  setTimeout(function() {$(".shopify-section.spaced-section.collection-grid-section").addClass('cstm-jdgm');}, 2500);
  setTimeout(function() {$(".shopify-section.product-section.spaced-section").addClass('cstm-jdgm');}, 2500);
  
  
  
  
$( document ).ready(function() {
     $(".img-new2").removeClass("slick-active");
});  
  
  
  $(".field__input").keyup(function(){
  $(".spn-eml").css("display", "none");
});
  
  $(".search__input").keyup(function(){
  
  $(".srch-new").css("display","none");
  
  });
  
  
  
  
$('.product-slider').slick({
  arrows: true,
  prevArrow: '<i class="fas fa-chevron-left"></i>',
   nextArrow: '<i class="fas fa-chevron-right"></i>',
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
				
  
  

  

  
  
  
  var count = 0;
$('#zoe-collection .card-wrapper').each(function() {
count ++;
    if($(this).text().match('Truffles')) {
        $(this).css('color', 'red'); 
jQuery("<div class='anchor_popup sfsdfsdf"+count+"' data-attr='"+count+"'><a href='javascript:void(0)' style='color:blue'>What’s Inside</a></div>").insertAfter(this);

    }      
});


  var count_cho = 0;


$('#chocolate-truffles  .card-wrapper').each(function() {
count_cho ++;
    if($(this).text().match('Truffles')) {     
        $(this).css('color', 'red'); 
jQuery("<div class='anchor_popup_second sfsdfsdf"+count_cho+"' data-counter='"+count_cho+"'><a href='javascript:void(0)' style='color:blue'>What’s Inside</a></div>").insertAfter(this);

    }      
});



 


var modal = jQuery("#myModal");
var span = jQuery("close");
jQuery("#zoe-collection .anchor_popup").each(function(){


jQuery(this).click(function(){
var bal = jQuery(this).attr("data-attr");
console.log(bal);
  if(bal == 4 ){

modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Birthday_Card_Final_22_-2.png?v=1637146289'/>"); $('body').addClass("popup");
}
if(bal == 5 ){

modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Birthday_Card_Final_22_-2.png?v=1637146289'/>"); $('body').addClass("popup");
}
else if(bal == 6 ){
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>"); $('body').addClass("popup");

}
else if(bal == 7 ){
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>"); $('body').addClass("popup");
}
else if(bal == 8 ){
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Birthday_Card_Final_22_-2.png?v=1637146289'/>"); $('body').addClass("popup");
}
else if(bal == 9 ){
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>"); $('body').addClass("popup");
}
else if(bal == 10 ){
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>"); $('body').addClass("popup");
}
});
});

// When the user clicks on <span> (x), close the modal
jQuery(".close").click(function(){
modal.fadeOut( 500 );
  $('body').removeClass("popup");
});
  
  
  
  
   var acd='https://www.cravingsbyzoe.com/collections/godiva-collection'
  
if(acd==window.location.href){
  
$("#menu-godiva").css("display", "block");
}
 


jQuery("#chocolate-truffles .anchor_popup_second").each(function(){


jQuery(this).click(function(){
// alert();
  
var bal1 = jQuery(this).attr("data-counter");
  if(bal1 == 4 ){

modal.fadeIn( 500 );
    
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Birthday_Card_Final_22_-2.png?v=1637146289'/>");
 $('body').addClass("popup");
  }
if(bal1 == 5 ){

modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>"); $('body').addClass("popup");
}
else if(bal1 == 6 ){
 
modal.fadeIn( 500 );
jQuery(".modal-content p").html("<img src='https://cdn.shopify.com/s/files/1/0607/0268/7450/files/CBZ_Everyday_Card_Final_OUT.png?v=1637146305'/>");
  $('body').addClass("popup");
}
});
});
  
$('.main_images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumb_images'
});
$('.thumb_images').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.main_images',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true

 
});
  
//   Responsive slider
  
  $('.main_images_responsive').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.thumb_images_reponsive'
});
$('.thumb_images_reponsive').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.main_images_responsive',
  dots: true,
  centerMode: false,
  focusOnSelect: true,
    
});

  $(".product_cstm_thumbnail .image_thumb_new").each(function(){
$(this).click(function(){
var src_attr=$(this).attr('src');

$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("src");
$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("srcset");

$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").attr("src", src_attr);

});

});





// $('input:radio').click(function(){
// setTimeout(function() {
// var new_gh=$(this).val();
// alert(new_gh);
// $(".images_use_main").each(function(){
// var new_gh2=$(this).find('img').attr('title_attr');
// if(new_gh == new_gh2){
// $(this).addClass('fg');
// $(this).siblings().removeClass('fg');
// var img_cstm_src=$(this).find('img').attr('src');
// $(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("src");
// $(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("srcset");
// $(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").attr("src", img_cstm_src);
// }
// });

//    }, 500);
// });


$('input:radio').click(function(){

var new_gh=$(this).val();

$(".images_use_main").each(function(){
var new_gh2=$(this).find('img').attr('title_attr');
if(new_gh == new_gh2){
$(this).addClass('fg');
$(this).siblings().removeClass('fg');
var img_cstm_src=$(this).find('img').attr('src');

setTimeout(function() {
$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("src");
$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").removeAttr("srcset");
$(".cstm_slider_new_div .product__media-item.grid__item.slider__slide:first-child .image_thumb_new").attr("src", img_cstm_src);
}, 50);
}
});

  
});

  



  
});